export default __webpack_public_path__ + "static/media/ktn.8d951238.png";